/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Whether membership of a directory group or a directory attribute value mapped the role.
 */
export const SourceKind = {
  Group: "group",
  Attribute: "attribute",
} as const;
/**
 * Whether membership of a directory group or a directory attribute value mapped the role.
 */
export type SourceKind = ClosedEnum<typeof SourceKind>;

export type ExplainedAccessDirectorySource = {
  /**
   * The directory attribute, for an attribute mapping.
   */
  attributeKey?: string | undefined;
  /**
   * The attribute value the member's profile matched, for an attribute mapping.
   */
  attributeValue?: string | undefined;
  /**
   * The directory group, for a group mapping.
   */
  directoryGroupName?: string | undefined;
  /**
   * Whether membership of a directory group or a directory attribute value mapped the role.
   */
  sourceKind: SourceKind;
};

/** @internal */
export const SourceKind$inboundSchema: z.ZodMiniEnum<typeof SourceKind> = z
  .enum(SourceKind);

/** @internal */
export const ExplainedAccessDirectorySource$inboundSchema: z.ZodMiniType<
  ExplainedAccessDirectorySource,
  unknown
> = z.pipe(
  z.object({
    attribute_key: z.optional(z.string()),
    attribute_value: z.optional(z.string()),
    directory_group_name: z.optional(z.string()),
    source_kind: SourceKind$inboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      "attribute_key": "attributeKey",
      "attribute_value": "attributeValue",
      "directory_group_name": "directoryGroupName",
      "source_kind": "sourceKind",
    });
  }),
);

export function explainedAccessDirectorySourceFromJSON(
  jsonString: string,
): SafeParseResult<ExplainedAccessDirectorySource, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ExplainedAccessDirectorySource$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ExplainedAccessDirectorySource' from JSON`,
  );
}
